import styled, { keyframes, css } from "styled-components";

export const Container = styled.div`
    width: 100%;
    height: 100%;
`

export const Content = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
`

export const Aside = styled.div`
    position: relative;
    flex: 2;
    display: flex;
    align-items: center;
    padding: 0 2rem;
    background: linear-gradient(0deg, #337CCF 0%, #2353B9 53%, #1C3FAF 100%);

    @media (max-width: 800px) {
        display: none;
    }
`

export const Main = styled.div`
    flex: 1;
    background: ${({ theme }) => theme.colors.__White};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    > .form--container {
        display: flex;
        height: 100%;
        width: 100%;
        padding: 1rem;
        justify-content: center;
    }
`

export const Form = {
    Wrapper: styled.div`
        display: flex;
        width: 100%;
        max-width: 400px;
        flex-direction: column;
        justify-content: center;
    `,
    Header: styled.div`
        display: flex;
        width: 100%;
        height: 15rem;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        .lo-mi4u {
            width: 8rem;
            height: 8rem;
            object-fit: contain;
        }

        .title{
            font-size: 2.2rem;
            font-weight: 100;
            text-align: center;
            margin-top: 2rem;
            color:${({ theme }) => theme.colors.__blue[550]};   
            span{
                font-weight: bold;
                color:${({ theme }) => theme.colors.__blue[550]};
            }
        }

        .separator {
            display: flex;
            margin-top: 1rem;
            width: 20rem;
            height: 2px;
            justify-content: center;
            align-items: center;
            background: ${({ theme }) => theme.colors.__blue[550]};
            border-radius: 1rem;
        }
    `,
    Content: styled.div`
        display: flex;
        width: 100%;
        height: 22rem;
        margin-top: 5rem;
        flex-direction: column;
        justify-content: space-between;

        .input--container {
            display: flex;
            flex-direction: column;
            gap: 3rem;
        }

        .input--login { 
           border-bottom: 2px solid ${({ theme }) => theme.colors.__blue[550]};
           box-shadow: 0px;
           height: 3.5rem;
        }

        .status--user{
            display: flex;
            width: 100%;
            height: 3rem;
            margin-top: 1rem;
            justify-content: space-around;
            align-items: center;
        }

        .radio-btn{
            span {
                color:${({ theme }) => theme.colors.__blue[550]};
            }
        }

        .wrapper-btn{
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    `
}

export const Footer = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    user-select: none;
    font-family: Montserrat, 'Helvetica Neue', sans-serif;
    color:${({ theme }) => theme.colors.__blue[550]};
    padding-bottom: 1rem;

    img{
        width: 5rem;
        height: 5rem;
    }

    .powered{
        display: flex;
        height: 1rem;
        align-items: center;
        gap: 0.5rem;
    } 
    .version{
        margin-top: .5rem;
    }
`

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Description = styled.p`
  z-index: 9;
  font-size: 3.5rem;
  font-weight: 400;
  color: #ffffff;
  transition: all 0.4s ease-in-out;
  opacity: 0;

  > span {
    font-size: 2.75rem;
    font-weight: 700;
  }

  ${({ $isVisible }) => $isVisible && css`
    animation: ${fadeIn} 0.5s ease-in-out forwards;
  `}
`;

export const ImageWrapper = styled.div`
    position: absolute;
    display: flex;

    > img {
        width: 100%;
        max-height: 90vh;
        opacity: 0.5;
    }
`

export const Button = styled.button`
    outline: none;
    border: none;
    width: 100%;
    height: 3rem;
    background-color:${({ theme }) => theme.colors.__blue[550]};
    margin-top: 4rem;
    border-radius: .5rem;
    color: ${({ theme }) => theme.colors.__white};
    font-weight: 800;
    font-size: 1.2rem;
    cursor: pointer;
    transition: all 0.3s ease-in-out;

    &:hover{
        transform: scale(1.05);
    }

    ${({ $isLoading }) => $isLoading && css`
        display: flex;  
        justify-content: center;
        align-items: center;
        width: 3rem;
        pointer-events: none;
    `}
`

export const Spinner = styled.div`
    width: 2rem;
    height: 2rem;
    border: 2px solid ${({ theme }) => theme.colors.__white};
    border-top: 2px solid transparent;
    border-radius: 50%;
    animation: spin 1s linear infinite;

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

`